import { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  Paper,
  TextInput,
  PasswordInput,
  Button,
  Text,
  Stack,
  Alert,
  ActionIcon,
  Box,
  useMantineColorScheme,
  useComputedColorScheme,
} from "@mantine/core";
import { IconAlertCircle, IconSun, IconMoon } from "@tabler/icons-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setColorScheme } = useMantineColorScheme();
  const colorScheme = useComputedColorScheme("light");
  const isDark = colorScheme === "dark";

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
    } catch (err: any) {
      setError(err.message || "Нэвтрэхэд алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isDark
          ? "var(--mantine-color-dark-8)"
          : "var(--mantine-color-gray-0)",
        position: "relative",
      }}
    >
      {/* Theme Toggle */}
      <ActionIcon
        variant="subtle"
        size="lg"
        color={isDark ? "yellow" : "blue"}
        onClick={() => setColorScheme(isDark ? "light" : "dark")}
        style={{ position: "absolute", top: 20, right: 20 }}
      >
        {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
      </ActionIcon>

      <Paper shadow="md" p="xl" w={400} radius="md">
        <Stack align="center" gap="xs" mb="xl">
          <img
            src={isDark ? "/logo-light.svg" : "/logo-dark.svg"}
            alt="YOLO Dataset"
            height={36}
          />
          <Text c="dimmed" size="sm">
            Админ самбар руу нэвтрэх
          </Text>
        </Stack>

        <form onSubmit={handleSubmit}>
          <Stack>
            {error && (
              <Alert
                icon={<IconAlertCircle size={16} />}
                color="red"
                variant="light"
                radius="md"
              >
                {error}
              </Alert>
            )}
            <TextInput
              label="Нэвтрэх нэр"
              placeholder="Нэвтрэх нэрээ оруулна уу"
              required
              value={username}
              onChange={(e) => setUsername(e.currentTarget.value)}
              size="sm"
            />
            <PasswordInput
              label="Нууц үг"
              placeholder="Нууц үгээ оруулна уу"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              size="sm"
            />
            <Button type="submit" fullWidth loading={loading} mt="xs" size="sm">
              Нэвтрэх
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
}
